import { Button, Header, LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'
import { cx } from '@/utils/cx'

export const EnrollmentStartPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { enrollmentStartPage: trans } = store.TranslationsState.translationsNew
  const [disabled, setDisabled] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)

  const handleProceed = () => {
    setDisabled(true)
    setBtnLoading(true)

    store.ScenarioState.nextPage()
  }

  return (
    <div className="page-container">
      <>
        <Illustration type="identity-verification" />

        <Header>{trans.header}</Header>

        <p className="generic__paragraph-centered">{trans.description}</p>
        <div className="layout__margined m-0-0-15" />

        <div className="layout__content-container-bottom-fixed">
          {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
          <Button
            disabled={disabled || btnLoading}
            onClick={handleProceed}
            className="button--w164"
            id="page-submit"
            type="submit"
          >
            {btnLoading && <LoadingSpinner inButton />}
            <span
              className={cx('generic__button-text', btnLoading && 'generic__button-text--loading')}
            >
              {trans.continue}
            </span>
          </Button>
        </div>
      </>
    </div>
  )
})
